import {
  checkCustomer,
  sendSignUpVerification,
  validateSignUpToken,
  getCustomer,
  updateCustomer,
  clearCustomer,
  getEmailUpdates,
  getCustomerEmail,
  validateEmail,
  updateCustomerGDPR,
  updateBookingGDPR,
  transferBookings,
  processCustomerFeedback,
} from '../actions/customer';

const initialState = {
  data: null,
  loading: false,
  emailUpdated: false,
  error: null,
  validateSignUpTokenError: null,
  customerChecked: false,
  signUpVerificationSentType: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case clearCustomer.TRIGGER:
      return { ...initialState };

    case checkCustomer.REQUEST:
      return {
        ...state,
        loading: true,
        customerChecked: false,
        error: null,
      };

    case sendSignUpVerification.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        signUpVerificationSentType: null,
      };

    case validateSignUpToken.REQUEST:
      return { ...state, loading: true, error: null, validateSignUpTokenError: null };

    case transferBookings.REQUEST:
    case getCustomer.REQUEST:
    case getCustomerEmail.REQUEST:
    case updateCustomerGDPR.REQUEST:
    case updateBookingGDPR.REQUEST:
    case validateEmail.REQUEST:
      return { ...state, loading: true, error: null };

    case updateCustomer.REQUEST:
      return { ...state, loading: false, error: null };

    case checkCustomer.SUCCESS:
    case getCustomer.SUCCESS:
    case getCustomerEmail.SUCCESS:
    case updateCustomer.SUCCESS:
    case validateSignUpToken.SUCCESS:
      // @ts-ignore ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
      return { ...state, data: { ...state.data, ...action.payload } };

    case processCustomerFeedback.SUCCESS:
      // @ts-ignore
      return { ...state, data: { ...state.data, feedbackGiven: true } };

    case updateCustomerGDPR.SUCCESS:
    case updateBookingGDPR.SUCCESS:
      // @ts-ignore ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
      return { ...state, data: { ...state.data, gdprConsent: true } };

    case sendSignUpVerification.SUCCESS:
      return { ...state, signUpVerificationSentType: action.payload };

    case getEmailUpdates.SUCCESS:
      // @ts-ignore ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
      return { ...state, data: { ...state.data, pendingEmail: action.payload } };

    case validateEmail.SUCCESS:
      return { ...state, emailUpdated: action.payload };

    case checkCustomer.FAILURE:
      return { ...state, data: null, error: action.payload };

    case sendSignUpVerification.FAILURE:
    case getCustomer.FAILURE:
    case getCustomerEmail.FAILURE:
    case updateCustomer.FAILURE:
    case updateCustomerGDPR.FAILURE:
    case updateBookingGDPR.FAILURE:
    case validateEmail.FAILURE:
      return { ...state, error: action.payload };

    case validateSignUpToken.FAILURE:
      return { ...state, validateSignUpTokenError: action.payload };

    case sendSignUpVerification.FULFILL:
    case validateSignUpToken.FULFILL:
    case getCustomer.FULFILL:
    case getCustomerEmail.FULFILL:
    case updateCustomer.FULFILL:
    case updateCustomerGDPR.FULFILL:
    case updateBookingGDPR.FULFILL:
    case transferBookings.FULFILL:
    case validateEmail.FULFILL:
      return { ...state, loading: false };

    case checkCustomer.FULFILL:
      return { ...state, loading: false, customerChecked: true };

    default:
      return state;
  }
};
